import type { SelectItem } from '@packages/shared';
import type { IntlShape } from 'react-intl';
import { subjectSelectMessages } from '../messages';
import { getFormattetMessage } from './getFormattetMessage';

export interface SubSelection {
  displayName?: string;
  value?: string;
}

/**
 * Convert the Selection Options from config to be used in the Select Component
 */
export const createFormSubSelectionsSelect = (
  obj: { [key: string]: string }[],
  intl: IntlShape,
): SelectItem[] =>
  obj.map((item) => {
    // find the message in subjectSelectMessages with the id from item
    const message = getFormattetMessage(subjectSelectMessages, item.label, intl);

    return {
      label: message,
      value: message,
    };
  });
